var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.976 12.509a.653.653 0 00-.116-.58.69.69 0 00-.543-.262h-11.73a.17.17 0 01-.168-.134l-.392-1.813c-.22-1-1.123-1.715-2.172-1.72A.844.844 0 008 8.833c0 .46.383.834.855.834a.511.511 0 01.501.4l2.165 10.046c.112.515.413.972.846 1.287a.164.164 0 01.009.26 1.31 1.31 0 00-.211 1.792 1.39 1.39 0 001.815.356c.608-.36.832-1.113.516-1.733a.162.162 0 01.007-.162.173.173 0 01.146-.079h4.083c.059 0 .114.03.145.079.031.049.034.11.008.162-.21.413-.186.902.063 1.294s.688.63 1.16.631c.475 0 .916-.24 1.165-.634s.27-.886.056-1.3a.157.157 0 01.007-.156.166.166 0 01.14-.077.844.844 0 00.855-.833.844.844 0 00-.855-.833h-7.78a.512.512 0 01-.502-.397l-.122-.57a.164.164 0 01.035-.139.173.173 0 01.133-.061h7.354c.925 0 1.735-.604 1.979-1.474l1.403-5.017z",
    fill: "#0D0C21",
    fillRule: "evenodd"
  })));
};

export default SvgCart;